// extracted by mini-css-extract-plugin
export default {"dashboardCard":"dashboard_dashboardCard__SMOWy","menuContainer":"dashboard_menuContainer__QvRup","menuItem":"dashboard_menuItem__cHu+E","menuIcon":"dashboard_menuIcon__fSzcY"};